export default function Declined() {
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #FFE1F5", backgroundColor: "#FCEFF7" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/declined.svg" alt="" />
      </div>
      <h5>
        Status:{" "}
        <span style={{ color: "#CD1951", fontWeight: "700" }}>Declined</span>
      </h5>
      <h6
        style={{
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
        }}
      >
        {" "}
        The customer declined this proposal.{" "}
      </h6>
    </div>
  );
}
